var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"smallImg",staticClass:"small-img"},_vm._l((_vm.list),function(item,i){return _c('el-image',{key:i,staticClass:"small-img-inner",attrs:{"src":item,"fit":"cover"}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }